module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/NA-29c631d84185f9ba4a3a5e30ba9ecd0b.png";